import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import LogoRef from '../../../assets/img/logoRef.png';
import FormValidator from '../../../utils/FormValidator';
import SuperSearchList from '../../shared/SuperSearch/SuperSearchList';
import { formatFax } from '../../../utils/Formatting';
import FormatPhoneNumber from '../../../utils/FormatPhoneNumber';
import isNull from '../../../utils/NullChecking';
import { Separator } from '../../EHR/utils/utils';
import { Modal, ModalBody } from "react-bootstrap";
import RenderField from '../../EHR/Intake Form/RenderField';
import NotificationHandler from '../../../utils/NotificationHandler';
import { enumUtil } from '../../../utils/Enum';
import { ServerRequestProtected, ServerRequestProtectedWithoutToken } from '../../../utils/ServerDataRequest';
import Loader from '../../shared/Loader/Loader';
import { IconAlert } from '../../shared/IconsComponent/icons';
// import { Separator } from '../utils/utils';

const IntakeEdit = (props) => {
    const { isOpenPopup = true, ID, intakeFormID: FormID, FormStatus, PatientID, onClose, onCloseSave } = { ...props }
    // Access specific query parameters
    // const ID = queryParams.get('id');
    const API_URL = enumUtil.controller.EHRTemplate;

    let FORM_DATA = {
        TemplateName: "",
        TemplateType: "",
        OTP: "",
        GuidID: ID,
        PatientName: ""
    }
    const [isLoading, setIsLoading] = useState(false);
    const [practiceData, setPracticeData] = useState({})
    const [formData, setFormData] = useState(FORM_DATA);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false)
    const [data, setData] = useState([])
    console.log("IntakeEdit?.data", data)

    const [intakePreviewData, setIntakePreviewData] = useState({});

    let valItemsModal = {}
    let ValidationItemsModal = {
    }
    const getItemType = (itemID) => {
        if (!itemID) return '';
        return itemID.split(/[-_:]/)[0];
    };
    const validateItemByType = (item, formData) => {
        const type = getItemType(item.ItemID);
        const isRequired = item.isRequired === "true" || item.isRequired === true;

        let validation = { isInvalid: false, message: "" };

        switch (type) {
            case "SimpleQuestion":
            case "Date":
            case "YesNoQuestion":
                {
                    let val = {
                        isInvalid: false,
                        options: false,
                        optionsError: "",
                        optionValidations: [],
                    };

                    const value = item.answer ?? "";

                    if (isRequired && !value) {
                        val.isInvalid = true;
                    }

                    validation = val;
                    break;
                }

            case "SingleChoice":
            case "MultiChoice":
            case "Dropdown":
            // case "Checklist":
            case "CheckList":
                {
                    const optionsArray = item.selectedOptions ? item.selectedOptions.split(Separator) : [];
                    console.log("SingleChoiceMultiChoiceDropdownCheckList", type, optionsArray)

                    let hasEmptyHintText = false; // flag if selected option has missing hint/value
                    let hasSelection = false;     // any option selected (contains (D))

                    const optionValidations = optionsArray.map(opt => {
                        const isSelected = opt.includes("(D)");
                        if (!isSelected) return false; // only validate selected options

                        hasSelection = true;

                        const metaMatch = opt.match(/\[(.*?)\]/)?.[1] || "";

                        // Extract TR, hintText, and typed value
                        const trFlag = metaMatch.match(/TR=(true|false)/)?.[1] ?? "false";
                        // const hintText = metaMatch.match(/hintText='(.*?)'/)?.[1] ?? "";
                        const typedValue = metaMatch.match(/value='(.*?)'/)?.[1] ?? "";

                        // Option is invalid if TR=true and BOTH hintText and typed value are empty
                        const isInvalid = trFlag === "true"
                            // && !hintText.trim() 
                            && !typedValue.trim();

                        if (isInvalid) hasEmptyHintText = true;

                        return isInvalid; // per-option invalid flag
                    });

                    const isInvalid =
                        (isRequired && !hasSelection) ||   // field-level required check
                        (hasSelection && hasEmptyHintText); // selected option TR + hint/value validation

                    validation = {
                        isInvalid, // overall field invalid
                        options: hasEmptyHintText, // option-level error flag
                        optionsError: hasEmptyHintText
                            ? "This Field Is Required!"
                            : "",
                        optionValidations, // array of true/false per option
                    };

                    break;
                }

            case "Table": {
                console.log("Table12345", item)
                const rowsArray = (typeof item.rows === "string" ? item.rows.split("\n") : item.rows ?? []);
                // Simple invalid check: any empty cell in any row
                const hasEmptyCell = rowsArray.some(row => (row || "").split(Separator).some(el => el.trim() === ""));

                if (isRequired && (rowsArray.length === 0 || hasEmptyCell)) {
                    validation = { isInvalid: true, message: "Table must have all cells filled" };
                }

                break;
            }

            case "Image":
            case "Signature": {
                // Image-specific validation logic
                const hasFile = !!item.file || (formData?.IsDefaultSignature);
                if (isRequired && !hasFile) {
                    validation = { isInvalid: true, message: `${type} is required` };
                }
                break;
            }

            default:
                break;
        }

        return validation;
    };
    const validateAllItems = (items, formData) => {
        const validationResult = {};

        (items || []).forEach(item => {
            const key = item.ItemID;
            validationResult[key] = validateItemByType(item, formData);
        });

        return validationResult;
    };
    const ValidationItems = async () => {
        const items = data?.[0]?.items;
        const ValidationItemsModal = validateAllItems(items, formData);

        await setValidationItemsModal(ValidationItemsModal)
        valItemsModal = ValidationItemsModal
    }
    const [validationItemsModal, setValidationItemsModal] = useState(ValidationItemsModal);

    const handleSetDefaultItemsForValidation = (Data) => {
        setValidationItemsModal(() => {
            return (Data || []).reduce((acc, item) => {
                acc[item.ItemID] = "";
                return acc;
            }, {});
        }
        );
    }
    console.log("validationItemsModalABC", validationItemsModal)
    const LoadData = (id) => {
        setIsLoading(true);
        setData([]);
        ServerRequestProtected(API_URL + "/FindByGUIDID", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
            "Value": id
        }).then((response) => {
            let { Data, EHRTemplateID, PracticeData, ...formData } = { ...response };
            setData(Data);
            handleSetDefaultItemsForValidation(Data?.[0]?.items || []);
            setFormData(prev => ({ ...prev, ...formData }))
            PracticeData && setPracticeData({ ...PracticeData[0] });
            setIsLoading(false);
        }).catch((error) => {
            console.log("ERROR", error)
            // This form is no longer available
            // This form has been removed and is no longer accessible.
            NotificationHandler("This form has been removed and is no longer accessible.", enumUtil.enumtoaster.error);
            setIsLoading(false);
        })
    }

    useEffect(() => {
        if (ID) {
            setFormData(prev => ({ ...prev, GuidID: ID }))
            LoadData(ID);
        }
    }, [ID])

    const handleSubmit = async () => {
        await ValidationItems();
        const validationItems = Object.values(valItemsModal).some(key => key.isInvalid);
        if (validationItems) {
            return
        } else {
            setIsLoading(true);
            // console.log("Data",data,formData)
            // OTP : '637428',
            let saveModal = {
                ...formData,
                PracticesID: String(practiceData?.PracticesID || ""),
                Data: [...data]
            }
            // console.log("saveModal",saveModal)
            ServerRequestProtected(API_URL + "/SavePatientIntakeForm", 'post', {
                ...saveModal
            }).then((response) => {
                setIsLoading(false);
                setIsFormSubmitted(true);
                // NotificationHandler("Form submitted successfully", enumUtil.enumtoaster.success);
            }).catch((error) => {
                console.log("ERROR", error)
                setIsLoading(false);
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
            })
        }
    }
    const handleClear = () => {
        setPracticeData({});
        setFormData(FORM_DATA);
        setData([]);
        LoadData(ID);
    }

    const formatAddress = (data) => {
        // Format >>>>> Address
        // >>>>>>>>>>>> City, State ZIP

        if (!data) return "";

        const { PracticeAddress, PracticeCity, PracticeState, PracticeZipCode } = practiceData;

        // First line → Address
        const line1 = PracticeAddress || "";
        // const line1 = practiceData?.Address || "";

        // Second line → City, State ZIP
        const cityStateZip = [PracticeCity, [PracticeState, PracticeZipCode].filter(Boolean).join(" ")].filter(Boolean).join(", ");

        // Combine with line break if both exist
        if (line1 && cityStateZip) return `${line1}<br />${cityStateZip}`;
        return line1 || cityStateZip || "";
    };
    const address = formatAddress(data);

    return (
        <>
            {/* {isLoading ? <Loader /> : null} */}

            <Modal show={isOpenPopup} onHide={isOpenPopup} backdrop="static" keyboard={false} centered dialogClassName="ar_merg-info-form-popup ar-merge-form-preview ar-admin-access-form">
                <Modal.Body>
                    {isLoading ? <Loader /> : null}
                    <div className="d-flex align-items-center justify-content-center gap-2 pt-15 ar_print-header pb-4">
                        <i className="icon-Icon-metro-cross fs-20" onClick={() => onClose()}></i>
                    </div>
                    {console.log("IntakeData", data, intakePreviewData)}

                    {data.length > 0 &&
                        (
                            <div>
                                <div className='ar_pat-info-form-fill d-flex justify-content-center h-100'>
                                    <div className="ar_fill-content-box d-flex flex-column gap-10  w-100 px-10 py-0">
                                        <div className="d-flex align-items-center justify-content-between bg-white br-bottom-1 za_br_light pb-1-5 practice-info">
                                            <div className="">
                                                <img src={practiceData?.img} alt="" style={{ maxHeight: '55px' }} />
                                            </div>
                                            <div className="text-center">
                                                {practiceData?.PracticeName ? <p className='heading text-black fs-16'>{practiceData?.PracticeName}</p> : ''}
                                                {address && (
                                                    <p className="text text-black fs-14" dangerouslySetInnerHTML={{ __html: address }} />
                                                )}
                                            </div>
                                            <div className="d-flex gap-10">
                                                <div className="">
                                                    <p className='text text-black font-m fs-14 pb-2px'>Tel:</p>
                                                    <p className='text text-black font-m fs-14'>Fax:</p>
                                                </div>
                                                <div className="">
                                                    <p className='text text-black  pb-2px fs-14'>{!isNull(practiceData?.Phone) ? FormatPhoneNumber(practiceData?.Phone) : practiceData?.Phone || 'N/A'}</p>
                                                    <p className='text text-black fs-14'>{formatFax(practiceData?.fax) || 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>


                                        {!isFormSubmitted &&
                                            <div className='ar-alert d-flex gap-1 mb-0 checkbox-multiline-alignment'>
                                                <IconAlert />
                                                <p className='text fs-11'>You are completing this form as a practice member. Please ensure the information entered has been confirmed with the patient before submitting. </p>
                                            </div>
                                        }
                                        <div className="bg-white">
                                            <p className="heading fs-16 lh-17 text-white form-heading">{formData?.TemplateName}</p>

                                            {["Submitted", "Processed"].includes(formData?.Status) || isFormSubmitted ? <></> :
                                                <p className="text fs-12 lh-14 form-instruction p-2">Please fill out all fields as accurately as possible. This information helps us provide you with the best care. If you need any assistance with completing this form, please don't hesitate to contact us.</p>}
                                        </div>

                                        <div className="ar_star-form-Preview ar-intake-form-fill">
                                            <div className="Form-content d-flex flex-column gap-10 pe-1 hover-scrollbar">
                                                {console.log("formDataTemplateType", formData?.TemplateType, data?.[0]?.key)}
                                                {formData?.Status === "Awaiting Response" ?
                                                    (!isFormSubmitted ?
                                                        <></> :
                                                        <div className='sucsses_meessage d-flex align-items-center gap-20 m-0'>
                                                            <div>
                                                                <i className='icon-tick-mark fs-49'></i>
                                                            </div>
                                                            <div >
                                                                <p className='fs-22 text font-m green_Color'>Form Submission Successful!</p>
                                                                <p className='text fs-14'>Thank you for submitting the form. If you need further assistance, feel free to contact us.</p>
                                                            </div>
                                                        </div>) : <></>}
                                                {["Submitted", "Processed"].includes(formData?.Status) ?
                                                    (<div className='sucsses_meessage d-flex align-items-center gap-20 m-0'>
                                                        <div>
                                                            <i className='icon-tick-mark fs-49'></i>
                                                        </div>
                                                        <div >
                                                            <p className='fs-22 text font-m green_Color'>This form is already submitted.</p>
                                                            <p className='text fs-14'>Thank you for submitting the form. If you need further assistance, feel free to contact us.</p>
                                                        </div>
                                                    </div>) :
                                                    (!isFormSubmitted &&
                                                        <>
                                                            {data[0]['items'].map(it => {
                                                                return <RenderField item={it} setItem={setData} validations={validationItemsModal?.[it?.ItemID]} activeAccordion={data?.[0]?.key || 'Intake Form'} patientName={formData?.PatientName} formData={formData} setFormData={setFormData} />
                                                            })}
                                                            <div className='d-flex justify-content-between align-items-center footer-btn px-10'>
                                                                <button className='btn btn-orange h-auto submit-btn fs-14 font-sb' onClick={handleSubmit}>Submit Form</button>
                                                                <p className='btn btn-outline  px-10 h-100 dark-clr' onClick={handleClear}>Clear Form</p>
                                                            </div>
                                                        </>)
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default IntakeEdit